/**
 * Colour roles for the Animals world figures. Storybook (A) values are hand-picked (warm, slightly
 * muted, ART-BIBLE §5); Sticker (B) and Pastel (C) are derived by `rolePalette`.
 * Shared roles (catFur, foxFur, cream, pink, eye, blush, leaf, water…) come from the base palette.
 */
import { rolePalette } from '../../art/palette';

export const ANIMALS_PALETTE = rolePalette({
  // fish
  fishBody: '#5FB3CF',
  fishFin: '#F29E5C',
  fishBelly: '#E6F4EE',
  fishScale: '#3F8DB0',
  // owl
  owlBrown: '#A8734E',
  owlDark: '#7B5037',
  owlFace: '#F6E5C8',
  owlBelly: '#EBD3AE',
  beak: '#F2B34A',
  branch: '#8A5A3C',
  // bunny
  bunnyFur: '#EFE6DE',
  carrot: '#EE8A3C',
  // turtle
  shell: '#7FAE5E',
  shellDark: '#5A8A47',
  shellRim: '#D8B878',
  turtleSkin: '#A9D07F',
  // hedgehog
  spines: '#9A6A4A',
  spinesDark: '#6E4733',
  hedgeFace: '#F2D6B4',
  apple: '#E0584E',
  // lion
  lionFur: '#F0B65C',
  mane: '#D98742',
  maneDark: '#B4642F',
  lionNose: '#8A4F3E',
  lionMuzzle: '#FBE6C2',
  // elephant
  elephantGrey: '#A9B6C6',
  elephantLight: '#CAD4DF',
  earPink: '#EDBDBA',
  // penguin
  penguinBody: '#3E4A66',
  beakOrange: '#F2A33A',
  penguinScarf: '#E0584E',
  ice: '#D7ECF4',
  // snail + bee
  snailShell: '#E9A15A',
  snailShellDark: '#C27434',
  snailBody: '#C2DC9E',
  beeYellow: '#F6C848',
  beeStripe: '#4A3A30',
  wing: '#E3F3F8',
  // v2: ladybug, flying bird, sheep, chick
  ladyRed: '#E2574C',
  birdBlue: '#6FA8D8',
  birdBelly: '#F6E4C6',
  sheepWool: '#F8F2E6',
  sheepWoolShade: '#E6DCCB',
  sheepFace: '#8A6E62',
  sheepHoof: '#5E4A42',
  chickYellow: '#F7D45C',
  chickWing: '#EDB93C',
  // v2 remix cards / scenes / crossovers
  catBow: '#D9577E',
  tigerStripe: '#B5562E',
  owlGlasses: '#7B5A45',
  owlBook: '#6FA6C9',
  owlBookPage: '#FFF8EA',
  owlScarf: '#5FA3A8',
  owlScarfStripe: '#F6E6B0',
  owlNightcap: '#7C8FD0',
  starShell: '#F3C451',
  starNight: '#4D5C9A',
  turtleMushCap: '#E0675A',
  turtleMushStem: '#F6E7CF',
  goggleLens: '#BFE6F2',
  goggleStrap: '#F08A4B',
  hedgeScarf: '#9C7BC4',
  animalPear: '#C9D96A',
  lionBaton: '#FFF8EA',
  lionBowTie: '#5B4BA0',
  musicNote: '#5B4BA0',
  maneFlowerA: '#F29BB4',
  maneFlowerB: '#F7D45C',
  maneFlowerC: '#B9A2E0',
  catCushion: '#E59A8A',
  catCushionDark: '#C9786C',
  catSunPatch: '#FBEFC9',
  pondWater: '#9FD3D8',
  pondStump: '#A7774F',
  pondStumpTop: '#E3C08F',
  pondReed: '#7FA65A',
  forestLog: '#8E623F',
  animalHillFar: '#C9DDB0',
  animalHillNear: '#A9C98A',
  concertNight: '#3F4C82',
  concertMoon: '#F6EDC9',
  concertRock: '#B9AFA4',
  concertRockDark: '#958A80',
  catSuit: '#F1F3F6',
  catSuitPanel: '#7FA3C9',
  catHelmet: '#CDEAF5',
  turtleCup: '#F7F4EE',
  turtleCupTrim: '#6FA6C9',
  turtleTea: '#C98B53',
  hedgeAcorn: '#C98A4E',
  hedgeAcornCap: '#8A5B35',
  owlCloak: '#5D5AA8',
  owlWizardHat: '#4C4996',
  owlWandStar: '#F6D25C',
});
